import './ModalConfiguration.scss'

import { Modal, ProgressBar } from "react-bootstrap";
import { useMemo, useState } from "react";

import ARStep1 from "./steps/ARStep1";
import ARStep2 from "./steps/ARStep2";
import ARStep3 from "./steps/ARStep3";
import ARStep4 from "./steps/ARStep4";
import AppContainer from "../../../../commons/containers/AppContainer";

function StepDots({ step, total }) {
  return (
    <div className="d-flex align-items-center gap-2 w-100">
      {Array.from({ length: total }).map((_, idx) => {
        const i = idx + 1;
        const active = i <= step;

        return (
          <div key={i} className="d-flex align-items-center flex-grow-1">
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: 999,
                background: active ? "#2f2a7a" : "#e7e7f4",
                border: active ? "1px solid #2f2a7a" : "1px solid #d8d8ee",
              }}
              aria-label={`Passo ${i}`}
            />
            {i !== total && (
              <div
                style={{
                  height: 2,
                  flex: 1,
                  marginLeft: 8,
                  marginRight: 8,
                  background: i < step ? "#2f2a7a" : "#e7e7f4",
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

function ModalConfiguration({ closeShow, show, getAllRecurrings }) {
  const TOTAL_STEPS = 4;

  const [step, setStep] = useState(1);
  const [data, setData] = useState({});

  const progress = useMemo(() => Math.round((step / TOTAL_STEPS) * 100), [step]);

  const next = (value) => {
    setData((prev) => ({ ...prev, ...value }));
    setStep((prev) => prev + 1);
  };

  const back = () => {
    setStep((prev) => prev - 1);
  };

  const stepTitle = useMemo(() => {
    switch (step) {
      case 1: return "Cliente e serviços";
      case 2: return "Frequência e dias";
      case 3: return "Duração e início";
      case 4: return "Revisão e confirmação";
      default: return "Agendamento Recorrente";
    }
  }, [step]);

  return (
    <Modal
      show={show}
      fullscreen="md-down"   // ✅ mobile full, desktop modal normal
      centered
      size="lg"
      onHide={() => closeShow()}
      contentClassName="hallapp-modal"
    >
      <Modal.Header closeButton className="border-bottom">
        <div className="w-100">
          <div className="d-flex align-items-start justify-content-between gap-2">
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 16, fontWeight: 700, lineHeight: "20px" }}>
                Agendamento Recorrente
              </div>
              <div className="text-muted" style={{ fontSize: 12 }}>
                {stepTitle} • Passo {step} de {TOTAL_STEPS}
              </div>
            </div>

            {/* Você pode colocar um mini "badge" aqui se quiser */}
          </div>

          <div className="mt-3">
            {/* ✅ Stepper visual */}
            <StepDots step={step} total={TOTAL_STEPS} />

            {/* ✅ E também uma barra (mais acessível e fácil de entender) */}
            <div className="mt-2">
              <ProgressBar now={progress} style={{ height: 6, borderRadius: 999 }} />
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <AppContainer>
          {step === 1 && <ARStep1 nextStep={next} />}
          {step === 2 && <ARStep2 nextStep={next} toBack={back} />}
          {step === 3 && <ARStep3 nextStep={next} toBack={back} />}
          {step === 4 && (
            <ARStep4
              data={data}
              toBack={back}
              closeModal={closeShow}
              getAllRecurrings={getAllRecurrings}
            />
          )}
        </AppContainer>
      </Modal.Body>
    </Modal>
  );
}

export default ModalConfiguration;
